import React, { useEffect, useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  InputAdornment,
  Button,
  OutlinedInput,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SchoolIcon from "@mui/icons-material/School";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import WorkIcon from "@mui/icons-material/Work";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";

import ClearIcon from "@mui/icons-material/Clear";
import { useSnackbar } from "notistack";
import { Clear } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import {
  get_education_list,
  get_experience_list,
  get_job_type_list,
} from "../../DAL/jobs/jobs";
import CircularLoader from "../../components/loader/CircularLoader";
import {
  bag_gray_icon,
  calender_gray_icon,
  calender_icon,
  cap_gray_icon,
  icon_1,
  map_gray_icon,
  salary_gray_icon,
  search_gray_icon,
  select_icon,
} from "../../assets";

const INITIAL_VALUES = {
  title: "",
  last_name: "",
  description: "",
  categories: [],
  status: true,
  image: null,
  imagePreview: null,
  videoURL: "",
  post_code: "",
  email: "",
  password: "",
  contact_number: "",
};

export default function JobsFilter(props) {
  const {
    handleFilterChange,
    filterValues,
    onCloseDrawer,
    handleFilterClear,
    applyFilters,
    refreshList,
  } = props;

  const [submitting, setSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(true);

  const [jobTypeList, setJobTypeList] = useState([]);
  const [educationList, setEducationList] = useState([]);
  const [experienceList, setExperienceList] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        // Call DAL functions in parallel
        const [experienceResp, educationResp, jobTypeResp] = await Promise.all([
          get_experience_list(),
          get_education_list(),
          get_job_type_list(),
        ]);

        if (experienceResp.code == 200) {
          setExperienceList(experienceResp.data);
        } else {
          enqueueSnackbar(experienceResp.message, { variant: "error" });
        }

        if (educationResp.code == 200) {
          setEducationList(educationResp.data);
        } else {
          enqueueSnackbar(educationResp.message, { variant: "error" });
        }

        if (jobTypeResp.code == 200) {
          setJobTypeList(jobTypeResp.data);
        } else {
          enqueueSnackbar(jobTypeResp.message, { variant: "error" });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  console.log(filterValues);

  if (loading) {
    return <CircularLoader />;
  }

  return (
    <form onSubmit={applyFilters} className="drawer-form">
      <div className="custom-input-design">
        <label htmlFor="">Search by keywords</label>
        <div className="position-relative">
          <input
            className="ps-5"
            name="clientName"
            placeholder="Job title, keywords , company"
            type="text"
            value={filterValues.clientName || ""}
            onChange={(e) => handleFilterChange(e)}
          />
          <img
            src={search_gray_icon}
            alt="lock_icon"
            className="input-start-icon"
          />
        </div>
      </div>

      <div className="custom-input-design mt-3">
        <label htmlFor="">Location</label>
        <div className="position-relative">
          <input
            className="ps-5"
            name="location"
            placeholder="City or postcode"
            value={filterValues.location || ""}
            onChange={(e) => handleFilterChange(e)}
          />
          <img
            src={map_gray_icon}
            alt="lock_icon"
            className="input-start-icon"
          />
        </div>
      </div>
      <div className="custom-input-design mt-3">
        <label htmlFor="">Salary Range</label>
      </div>
      <div className="d-flex gap-3">
        <div className="custom-input-design">
          <div className="position-relative">
            <input
              placeholder="Min Salary"
              className="ps-5"
              name="minSalary"
              type="number"
              value={filterValues.minSalary || ""}
              onChange={(e) => handleFilterChange(e)}
            />
            <img
              src={salary_gray_icon}
              alt="lock_icon"
              className="input-start-icon"
            />
          </div>
        </div>

        <div className="custom-input-design">
          <div className="position-relative">
            <input
              placeholder="Max Salary"
              className="ps-5"
              type="number"
              name="maxSalary"
              value={filterValues.maxSalary || ""}
              onChange={(e) => handleFilterChange(e)}
            />
            <img
              src={salary_gray_icon}
              alt="lock_icon"
              className="input-start-icon"
            />
          </div>
        </div>
      </div>
      <div className="custom-input-design mt-3">
        <label htmlFor="">Frequency Salary</label>
        <div className="d-flex flex-wrap gap-2">
          <button
            name="frequency"
            value={"Hourly"}
            type="button"
            className={`input-gray-chip ${
              filterValues.frequency === "Hourly"
                ? "input-gray-chip-active"
                : ""
            }`}
            onClick={(e) => {
              handleFilterChange(e);
            }}
          >
            Hourly
          </button>
          <button
            name="frequency"
            value={"Yearly"}
            type="button"
            className={`input-gray-chip ${
              filterValues.frequency === "Yearly"
                ? "input-gray-chip-active"
                : ""
            }`}
            onClick={(e) => {
              handleFilterChange(e);
            }}
          >
            Yearly
          </button>
        </div>
      </div>

      <div className="custom-input-design mt-3">
        <label htmlFor="">Job Type</label>
        <div className="d-flex flex-wrap gap-2">
          {jobTypeList.map((obj) => (
            <button
              name="jobType"
              value={filterValues?.jobType?.slug || ""}
              type="button"
              className={`input-gray-chip ${
                obj.slug === filterValues?.jobType?.slug
                  ? "input-gray-chip-active"
                  : ""
              }`}
              onClick={(e) => {
                handleFilterChange(e, obj);
              }}
            >
              {obj.title}
            </button>
          ))}
        </div>
      </div>

      <div className="custom-input-design mt-3">
        <label>Experience</label>

        <div className="position-relative">
          <select
            className="ps-5"
            name="experience"
            value={filterValues?.experience?.slug || ""}
            onChange={(e) =>
              handleFilterChange(
                e,
                experienceList.find((obj) => obj.slug == e.target.value)
              )
            }
          >
            <option value="" disabled hidden selected>
              Select Experience
            </option>

            {experienceList.map((obj) => (
              <option key={obj.slug} value={obj.slug}>
                {obj.title}
              </option>
            ))}
          </select>
          <img src={bag_gray_icon} className="input-start-icon" alt="" />
          <img src={select_icon} className="input-end-icon pe-none" alt="" />
        </div>
      </div>

      <div className="custom-input-design mt-3">
        <label>Education</label>

        <div className="position-relative">
          <select
            className="ps-5"
            name="education"
            value={filterValues?.education?.slug || ""}
            onChange={(e) =>
              handleFilterChange(
                e,
                educationList.find((obj) => obj.slug == e.target.value)
              )
            }
          >
            <option value="" disabled hidden selected>
              Select Education
            </option>

            {educationList.map((obj) => (
              <option key={obj.slug} value={obj.slug}>
                {obj.title}
              </option>
            ))}
          </select>
          <img src={cap_gray_icon} className="input-start-icon" alt="" />
          <img src={select_icon} className="input-end-icon pe-none" alt="" />
        </div>
      </div>

      <div className="custom-input-design mt-3">
        <label>Filter by Date</label>

        <div className="position-relative">
          <select
            className="ps-5"
            name="dateFilter"
            value={filterValues?.dateFilter || ""}
            onChange={(e) => handleFilterChange(e)}
          >
            <option value="" disabled hidden>
              Select Date
            </option>

            <option value="last24hours">Last 24 hours</option>
            <option value="last3days">Last 3 days</option>
            <option value="last7days">Last 7 days</option>
            <option value="last14days">Last 14 days</option>
            <option value="custom">Custom Dates</option>
          </select>

          {/* Start Icon */}
          <img
            src={calender_gray_icon}
            className="input-start-icon"
            alt="calendar"
          />

          {/* End Icon */}
          <img
            src={select_icon}
            className="input-end-icon pe-none"
            alt="dropdown"
          />
        </div>
      </div>

      {filterValues.dateFilter === "custom" && (
        <>
          <div className="custom-input-design mt-3">
            <label htmlFor="">Start Date</label>
            <div className="position-relative">
              <input
                className=""
                name="startDate"
                label="Start Date"
                type="date"
                value={filterValues.startDate || ""}
                onChange={(e) => handleFilterChange(e)}
              />
            </div>
          </div>

          <div className="custom-input-design mt-3">
            <label htmlFor="">End Date</label>
            <div className="position-relative">
              <input
                placeholder="Max Salary"
                name="endDate"
                label="End Date"
                type="date"
                value={filterValues.endDate || ""}
                onChange={(e) => handleFilterChange(e)}
              />
            </div>
          </div>
        </>
      )}
      <div className="filter-footer">
        <div className="row w-100">
          <div className="col-6">
            <button
              className="theme-button-outlined btn-big w-100"
              onClick={handleFilterClear}
              variant="outlined"
              color="primary"
              fullWidth
            >
              Clear
            </button>
          </div>
          <div className="col-6">
            <button
              className="theme-button-contained btn-big w-100"
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
